// Loader.jsx
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import '../loader/loader.css'; // your animation styles

const Loader = ({ loadingText, downloadPercentage }) => {
  const [mounted, setMounted] = useState(false);
  const text = 'SMART PROPOSAL';

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  const loaderMarkup = (
    <div
      className="spinnerMain fixed inset-0 z-[100002] bg-black bg-opacity-60 flex justify-center items-center"
      role="alert"
      aria-live="assertive"
    >
      <div className="loadingScreen text-center">
        <h3 className="loadingScreen__text">
          {text.split('').map((char, index) => (
            <span
              key={index}
              className="loadingScreen__text__span"
              style={{ '--i': index + 1 }}
            >
              {char}
            </span>
          ))}
        </h3>
        {loadingText && (
          <>
            <div className="loadingProgress mt-4 text-white">{loadingText}</div>
            <div className="progressBarContainer mt-2 w-full max-w-md mx-auto bg-gray-300 rounded overflow-hidden">
              <div
                className="progressBar bg-blue-500 h-2 transition-all duration-300"
                style={{ width: `${downloadPercentage}%` }}
                aria-valuenow={downloadPercentage}
                aria-valuemin="0"
                aria-valuemax="100"
                role="progressbar"
              ></div>
            </div>
          </>
        )}
      </div>
    </div>
  );

  return ReactDOM.createPortal(loaderMarkup, document.body);
};

export default Loader;
